import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { usePost } from "../../../hooks/usePost";
import { lightGreyOutline } from "../../../styles";
import {
  FlexibleContainer,
  HorizontalLine,
  RowContainer,
} from "../../../components/containers/styledComponents";
import { mockCoverage } from "../NetZeroAssessment/mockData";
import { CompanyCoverage } from "../NetZeroAssessment/Coverage";
import { ProviderTab } from "../NetZeroAssessment/ProviderTab";
import {
  Coverage,
  Provider,
  PublicMetric,
} from "../../../models/CompanyprofileModels";
import { buildCoverageData } from "../NetZeroAssessment/util";
import { useToast } from "../../../store/ToastProvider";
import { MESSAGES } from "../../../messages";
import { TabNA100 } from "../NetZeroAssessment/TabNA100";

const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
`;

export const CompanyEnvironmentalProfile = ({
  companyId,
}: {
  companyId: string;
}): JSX.Element => {
  const [activeTab, setActiveTab] = useState<Provider>(Provider.NA100);
  const { addToast } = useToast();

  const {
    data: metricsData,
    sendData: getMetricsData,
    isLoading: isMetricsDataLoading,
    error: getMetricsDataError,
  } = usePost<PublicMetric[], { compass_cid: string; company_name: null }>();

  useEffect(() => {
    getMetricsData("GET_COMPANY_PUBLIC_METRICS", {
      compass_cid: companyId,
      company_name: null,
    });
  }, []);

  useEffect(() => {
    if (getMetricsDataError) {
      addToast(MESSAGES.SCREENING_TOOL.ERROR_FETCHING_PUBLIC_METRICS, "error");
    }
  }, [getMetricsDataError]);

  const renderProviderComponent = (isLoading: boolean): JSX.Element => {
    if (isLoading) {
      return (
        <FlexibleContainer
          w="100%"
          fd="column"
          p="10px 5px"
          jc="center"
          ai="flex-start"
          br="6px"
          h="32px"
          isLoading={isLoading}
          ml="12px"
        ></FlexibleContainer>
      );
    }
    switch (activeTab) {
      case Provider.NA100:
        return <TabNA100 metricsData={metricsData || []} />;
      default:
        return <TabNA100 metricsData={metricsData || []} />;
    }
  };

  const allCoverage = metricsData
    ? buildCoverageData(metricsData)
    : mockCoverage;
  // Environmental Profile only shows NA100
  const coverage: Record<Provider, Coverage> = {
    [Provider.SBTI]: { title: "", isCovered: false },
    [Provider.TPI]: { title: "", isCovered: false },
    [Provider.CA100]: { title: "", isCovered: false },
    [Provider.NZIF]: { title: "", isCovered: false },
    [Provider.NA100]: allCoverage[Provider.NA100],
  };
  const shouldDisplayTabs: boolean = coverage[Provider.NA100].isCovered;

  return (
    <Container>
      <CompanyCoverage coverage={coverage} isLoading={isMetricsDataLoading} />
      {shouldDisplayTabs && (
        <>
          <RowContainer jc="center" ai="center">
            <HorizontalLine
              marginTop={1}
              color={lightGreyOutline}
              thickness={2}
            />
          </RowContainer>

          <ProviderTab
            coverage={coverage}
            handleSetActiveTab={setActiveTab}
            isLoading={isMetricsDataLoading}
          />

          <RowContainer>
            {renderProviderComponent(isMetricsDataLoading)}
          </RowContainer>
        </>
      )}
    </Container>
  );
};
